module.exports = __webpack_public_path__ + "img/mamma-mia-here-we-go-again-logo.2c220a64.png";